import { registerBlock } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const test: ContentBlock<"test"> = {
  id: makeId("test-prolactin"),
  kind: "test",
  tags: ["testing", "her", "pre-cycle"],
  title: "Prolactin",
  subtitle: "Screens for elevated prolactin that can suppress ovulation",
  body: {
    testName: "Prolactin",
    category: "blood-marker",
    whatItMeasures:
      "Elevated prolactin can suppress ovulation. Screens for hyperprolactinemia.",
    howItWorks:
      "Blood draw, often scheduled 3-4 hours after waking. Some clinics request fasting. Stress and recent breast stimulation can temporarily raise levels, so an unexpected high value may be repeated under calmer conditions.",
    quickFacts: [
      { kind: "sample", value: "Blood" },
      { kind: "time", value: "5 min draw" },
      { kind: "pain", value: "Needle pinch" },
      { kind: "prep", value: "Often 3-4 hours after waking" },
      { kind: "results", value: "1-3 business days" },
    ],
    turnaroundTime: "1-3 business days",
    costRange: { low: 25, high: 100 },
    atHome: false,
    clinicRequired: false,
    cycleDay:
      "Any cycle day; timing after waking and stress level matter more than menstrual cycle day.",
    markerTiming: [
      {
        marker: "Prolactin",
        timing: "Any cycle day, often 3-4 hours after waking",
        reason:
          "Prolactin changes through the day and can rise with stress, exercise, sleep, or breast stimulation, so repeat testing is sometimes used to confirm a high result.",
      },
    ],
    dataPoints: [makeId("dp-prolactin-level")],
  },
  sources: [
    {
      title:
        "Diagnosis and treatment of hyperprolactinemia: an Endocrine Society clinical practice guideline",
      authors:
        "Melmed S, Casanueva FF, Hoffman AR, Kleinberg DL, Montori VM, Schlechte JA, Wass JAH",
      journal: "Journal of Clinical Endocrinology & Metabolism",
      year: 2011,
      url: "https://www.endocrine.org/clinical-practice-guidelines/hyperprolactinemia",
      evidenceLevel: "guideline",
    },
  ],
  readTimeMinutes: 3,
};

registerBlock(test);
